export default class Url
  pushParamsToUrl: (options) ->
    if typeof options == "object"
      url = @locationOrigin() + window.location.pathname + '?' + @mapToQueryString(options.params)
    else if typeof options == "string"
      url = @locationOrigin() + window.location.pathname + '?' + options
    window.history.pushState(url, "", url)

  mapToQueryString: (map) ->
    return "" if Object.keys(map).length == 0
    (("#{k}=#{escape(v)}&" for k,v of map).reduceRight (x, y) -> x + y).slice(0, -1)

  replaceValueInQueryString: (queryString, key, value) ->
    queryMap = @queryToMap(queryString)
    queryMap[key] = value
    '?' + @mapToQueryString(queryMap)

  locationOrigin: ->
    if window.location.origin
      window.location.origin
    else
      window.location.protocol + "//" + window.location.hostname

  queryToMap: (queryString) ->
    queryMap = {}
    queryMap[pair.split('=')[0]] = unescape(pair.split('=')[1]) for pair in queryString.substring(1).split('&')
    return queryMap



// WEBPACK FOOTER //
// ./app/javascript/utils/shared/url.js.coffee